import { HIDE_SCANX, HIDE_OBLOANE } from './utils/featureFlags';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster, toast } from 'sonner';
import { fetchApi } from './utils/api';
import GlobalSearch from './components/GlobalSearch';
import LanguageSelector from './components/common/LanguageSelector';
import WhatsAppFloat from './components/common/WhatsAppFloat';
import { trackClick, trackPageview } from './services/analyticsService';
import { lazyPage, PageFallback } from './utils/lazyPage';

// Pages
import Login from './pages/Login';
import WelcomePage from './pages/WelcomePage';
import LeadCaptureGate from './components/LeadCaptureGate';

// Forme neregulate (modul izolat)

// Pagini modulare Configurare

// Icons
import { 
  Home, LogOut, Menu, X, Type, ChevronLeft, Map
} from 'lucide-react';

// Ecrane incarcate la cerere (code splitting)
const Register = lazyPage(() => import('./pages/Register'));
const UitatParolaPage = lazyPage(() => import('./pages/UitatParolaPage'));
const ReseteazaParolaPage = lazyPage(() => import('./pages/ReseteazaParolaPage'));
const ActivareCampaniePage = lazyPage(() => import('./pages/ActivareCampaniePage'));
const SitemapPage = lazyPage(() => import('./pages/SitemapPage'));
const CalculSimplificatObloanePage = lazyPage(() => import('./pages/CalculSimplificatObloanePage'));
const CalculSimplificatFerestreUsiPage = lazyPage(() => import('./pages/CalculSimplificatFerestreUsiPage'));
const FirmaDataPage = lazyPage(() => import('./pages/FirmaDataPage'));
const SchimbaParolaPage = lazyPage(() => import('./pages/SchimbaParolaPage'));
const ValabilitateLicentaPage = lazyPage(() => import('./pages/ValabilitateLicentaPage'));
const IstoricOfertePage = lazyPage(() => import('./pages/IstoricOfertePage'));
const Dashboard = lazyPage(() => import('./pages/Dashboard'));
const Furnizori = lazyPage(() => import('./pages/Furnizori'));
const Produse = lazyPage(() => import('./pages/Produse'));
const Mapari = lazyPage(() => import('./pages/Mapari'));
const Facturi = lazyPage(() => import('./pages/Facturi'));
const Grupuri = lazyPage(() => import('./pages/Grupuri'));
const Drepturi = lazyPage(() => import('./pages/Drepturi'));
const Utilizatori = lazyPage(() => import('./pages/Utilizatori'));
const SesiuniPage = lazyPage(() => import('./pages/SesiuniPage'));
const StatisticiClicuriPage = lazyPage(() => import('./pages/StatisticiClicuriPage'));
const DocumentePage = lazyPage(() => import('./pages/DocumentePage'));
const DocuPPage = lazyPage(() => import('./pages/DocuPPage'));
const FormaNeregulataPage = lazyPage(() => import('./forme_neregulate/FormaNeregulataPage'));
const FeronerePage = lazyPage(() => import('./pages/configurare/FeronerePage'));
const CuloriPage = lazyPage(() => import('./pages/configurare/CuloriPage'));
const LemnPage = lazyPage(() => import('./pages/configurare/LemnPage'));
const SchemePage = lazyPage(() => import('./pages/configurare/SchemePage'));
const FeronerieSetupPage = lazyPage(() => import('./pages/configurare/FeronerieSetupPage'));
const GeamPage = lazyPage(() => import('./pages/configurare/GeamPage'));
const OperatiiPage = lazyPage(() => import('./pages/configurare/OperatiiPage'));
const CalculatiiPage = lazyPage(() => import('./pages/configurare/CalculatiiPage'));
const CorelatiiPage = lazyPage(() => import('./pages/configurare/CorelatiiPage'));
const CosturiPage = lazyPage(() => import('./pages/configurare/CosturiPage'));
const FinisajPage = lazyPage(() => import('./pages/configurare/FinisajPage'));
const PraguriPage = lazyPage(() => import('./pages/configurare/PraguriPage'));
const PicuratoriPage = lazyPage(() => import('./pages/configurare/PicuratoriPage'));
const TipologiiPage = lazyPage(() => import('./pages/configurare/TipologiiPage'));
const TipuriOptiuniPage = lazyPage(() => import('./pages/configurare/TipuriOptiuniPage'));
const DimensiuniPage = lazyPage(() => import('./pages/configurare/DimensiuniPage'));
const JocuriPage = lazyPage(() => import('./pages/configurare/JocuriPage'));
const CoteVitrajPage = lazyPage(() => import('./pages/configurare/CoteVitrajPage'));
const DocumenteTehnicePage = lazyPage(() => import('./pages/configurare/DocumenteTehnicePage'));
const SpecialePage = lazyPage(() => import('./pages/configurare/SpecialePage'));
const SprosePage = lazyPage(() => import('./pages/configurare/SprosePage'));
const PlacariPage = lazyPage(() => import('./pages/configurare/PlacariPage'));
const AccesoriiPage = lazyPage(() => import('./pages/configurare/AccesoriiPage'));
const ProfileSuplimentarePage = lazyPage(() => import('./pages/configurare/ProfileSuplimentarePage'));
const CorelatiiPSPage = lazyPage(() => import('./pages/configurare/CorelatiiPSPage'));
const EtansarePage = lazyPage(() => import('./pages/configurare/EtansarePage'));
const ImaginiPage = lazyPage(() => import('./pages/configurare/ImaginiPage'));
const ScanXPage = lazyPage(() => import('./pages/configurare/ScanXPage'));
const VocePage = lazyPage(() => import('./pages/VocePage'));
const ConfiguratorPage = lazyPage(() => import('./pages/configurare/ConfiguratorPage'));
const ObloanePage = lazyPage(() => import('./pages/configurare/ObloanePage'));
const ProfileObloanePage = lazyPage(() => import('./pages/configurare/obloane/ProfilePage'));
const TipologiiObloanePage = lazyPage(() => import('./pages/configurare/obloane/TipologiiPage'));
const CorelatiiObloanePage = lazyPage(() => import('./pages/configurare/obloane/CorelatiiPage'));
const FeronerieTipuriObloanePage = lazyPage(() => import('./pages/configurare/obloane/FeronerieTipuriPage'));
const FeronerieSeturiObloanePage = lazyPage(() => import('./pages/configurare/obloane/FeronerieSeturiPage'));
const LamelePreturiObloanePage = lazyPage(() => import('./pages/configurare/obloane/LamelePreturiPage'));
const ObloaneLemnPage = lazyPage(() => import('./pages/configurare/obloane/ObloaneLemnPage'));
const ObloaneDimensiuniPage = lazyPage(() => import('./pages/configurare/obloane/DimensiuniPage'));
const OblonLemnOfertarePage = lazyPage(() => import('./pages/OblonLemnOfertarePage'));
const MediaPage = lazyPage(() => import('./pages/configurare/MediaPage'));
const FeronerieSeturiPage = lazyPage(() => import('./pages/configurare/FeronerieSeturiPage'));
const SchemeFeronerieUsiPage = lazyPage(() => import('./pages/configurare/SchemeFeronerieUsiPage'));
const ImportPreturiPage = lazyPage(() => import('./pages/configurare/ImportPreturiPage'));
const VariabileLunarePage = lazyPage(() => import('./pages/configurare/VariabileLunarePage'));
const PierderiPage = lazyPage(() => import('./pages/configurare/PierderiPage'));
const BIEvolutivePage = lazyPage(() => import('./pages/BIEvolutivePage'));
const DescarcariPage = lazyPage(() => import('./pages/DescarcariPage'));
const BIComparativTariPage = lazyPage(() => import('./pages/BIComparativTariPage'));
const RapoarteUtilizatoriPage = lazyPage(() => import('./pages/RapoarteUtilizatoriPage'));
const BIRataSuccesPage = lazyPage(() => import('./pages/BIRataSuccesPage'));
const BITopPage = lazyPage(() => import('./pages/BITopPage'));
const BIDealerAdaosServiciiPage = lazyPage(() => import('./pages/BIDealerAdaosServiciiPage'));
const ComenzileMelePage = lazyPage(() => import('./pages/ComenzileMelePage'));
const ServiciiPage = lazyPage(() => import('./pages/ServiciiPage'));
const OferteAdminPage = lazyPage(() => import('./pages/OferteAdminPage'));
const ConstructiiPage = lazyPage(() => import('./pages/ConstructiiPage'));
const ConstructiiProiectPage = lazyPage(() => import('./pages/ConstructiiProiectPage'));
const CalculSimplificatConstructiiPage = lazyPage(() => import('./pages/CalculSimplificatConstructiiPage'));
const WelcomeConstructiiPage = lazyPage(() => import('./pages/WelcomeConstructiiPage'));

// BI Placeholder Page
const BIPlaceholderPage = ({ titlu }) => (
  <div className="p-6">
    <h1 className="text-xl font-bold text-gray-900">{titlu}</h1>
    <p className="text-sm text-gray-500 mt-1">In constructie</p>
    <div className="mt-8 text-center py-16 border rounded-lg bg-gray-50 text-gray-400">
      <p className="text-lg">Pagina va fi disponibila in curand</p>
    </div>
  </div>
);

// Layout component
const Layout = ({ children }) => {
  const { user, logout, canView, isAdmin } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [brandLightboxOpen, setBrandLightboxOpen] = React.useState(false);
  const [panouCompact, setPanouCompact] = React.useState(false);
  React.useEffect(() => {
    const handler = (e) => setPanouCompact(Boolean(e?.detail?.compact));
    window.addEventListener('panou-compact-mode', handler);
    return () => window.removeEventListener('panou-compact-mode', handler);
  }, []);
  const [fontSize, setFontSize] = React.useState(() => {
    return parseInt(localStorage.getItem('fontSize') || '100');
  });

  // Sesiune fork v5.2.12: avertizare la intrarea in aplicatie daca utilizatorul
  // are cel putin un adaos_pct != 0 setat in pagina Servicii.
  // Banner dismiss-abil (sessionStorage), reapare la urmatorul login/refresh complet.
  const [adaosWarn, setAdaosWarn] = React.useState(false);
  React.useEffect(() => {
    if (!user || user.rol === 'guest') { setAdaosWarn(false); return; }
    if (sessionStorage.getItem('adaos_warn_dismissed') === '1') { setAdaosWarn(false); return; }
    let cancelled = false;
    fetchApi('/api/comenzi/servicii/adaos')
      .then(r => (r && r.ok) ? r.json() : null)
      .then(d => {
        if (cancelled || !d) return;
        const has = (d.items || []).some(it => Number(it.adaos_pct) !== 0);
        setAdaosWarn(has);
      })
      .catch(() => { /* fail-safe: nu afisam banner daca endpoint-ul nu raspunde */ });
    return () => { cancelled = true; };
  }, [user]);
  const dismissAdaosWarn = () => {
    sessionStorage.setItem('adaos_warn_dismissed', '1');
    setAdaosWarn(false);
  };

  // Aplica marimea fontului la fiecare navigare
  React.useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}%`;
    localStorage.setItem('fontSize', fontSize.toString());
  }, [fontSize, location.pathname]);

  // Seteaza clasa pe body pt roluri (ascunde butoanele delete pt non-admin)
  React.useEffect(() => {
    if (isAdmin) {
      document.body.classList.add('role-admin');
      document.body.classList.remove('role-user');
    } else {
      document.body.classList.add('role-user');
      document.body.classList.remove('role-admin');
    }
  }, [isAdmin]);

  const cycleFontSize = () => {
    const sizes = [100, 110, 120];
    const currentIndex = sizes.indexOf(fontSize);
    const nextIndex = (currentIndex + 1) % sizes.length;
    const newSize = sizes[nextIndex];
    setFontSize(newSize);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Navigare cu 3 sectiuni separate - puncte colorate pe sectiuni
  const navSections = [
    {
      title: null, // Prima sectiune fara titlu (Welcome + Sitemap)
      dotColor: null,
      showForAll: true,
      showForGuest: true,
      items: [
        { to: '/welcome', icon: Home, label: t('nav.bun_venit', 'Bun venit'), ecranId: 'welcome', modul: 'dashboard', showForDistributor: true, showForAll: true, showForGuest: true },
        { to: '/harta-site', icon: Map, label: t('nav.harta_site', 'Harta site'), ecranId: 'harta-site', modul: 'dashboard', showForDistributor: true, showForAll: true, showForGuest: true },
        { to: '/', icon: Home, label: t('nav.dashboard'), ecranId: 'dashboard', modul: 'dashboard' },
      ]
    },
    {
      title: t('nav.calcul_simplificat', 'CALCUL SIMPLIFICAT'),
      titleColor: 'text-red-600',
      dotColor: 'bg-red-500',
      showForAll: true,
      showForGuest: true,
      items: [
        { to: '/calcul-simplificat-obloane', label: t('nav.calcul_simplificat_obloane', 'Simplificat Obloane'), ecranId: 'calcul-simplificat-obloane', modul: 'scan-x', showForDistributor: true, showForGuest: true },
        { to: '/calcul-simplificat-ferestre-usi', label: t('nav.calcul_simplificat_ferestre_usi', 'Simplificat Ferestre/Usi'), ecranId: 'calcul-simplificat-ferestre-usi', modul: 'scan-x', showForDistributor: true, showForGuest: true },
        { to: '/istoric-oferte', label: t('nav.istoric_oferte', 'Istoric oferte'), ecranId: 'istoric-oferte-simplu', modul: 'scan-x', showForDistributor: true, showForGuest: true },
      ]
    },
    {
      title: t('nav.calcul_complex', 'CALCUL COMPLEX'),
      titleColor: 'text-blue-600',
      dotColor: 'bg-blue-500',
      showForAll: true,
      showForGuest: true,
      items: [
        { to: '/obloane-lemn', label: t('configurator:ot.welcome_obloane_lemn_title', 'Obloane Lemn'), ecranId: 'obloane-lemn', modul: 'scan-x', showForDistributor: true, showForGuest: true, regLock: true },
        { to: '/configurator', label: t('nav.configurator'), ecranId: 'configurator', modul: 'scan-x', showForDistributor: true, showForGuest: true, regLock: true },
        { to: '/scan-x', label: t('nav.scan_x'), ecranId: 'scan-x', modul: 'scan-x', showForDistributor: true, showForGuest: true, regLock: true },
        { to: '/voce', label: t('nav.voce', 'VOCE'), ecranId: 'scan-x', modul: 'scan-x', showForDistributor: true, showForGuest: true, regLock: true },
        { to: '/istoric-oferte', label: t('nav.istoric_oferte', 'Istoric oferte'), ecranId: 'istoric-oferte-complex', modul: 'scan-x', showForDistributor: true, showForGuest: true, regLock: true },
      ]
    },
    {
      title: t('sitemap.cat_comenzi', 'COMENZI').toUpperCase(),
      titleColor: 'text-rose-600',
      dotColor: 'bg-rose-500',
      showForAll: true,
      showForGuest: true,
      items: [
        { to: '/comenzi-mele', label: t('comenzi_page.title', 'Comenzile mele'), ecranId: 'comenzi-mele', modul: 'scan-x', showForDistributor: true, showForGuest: true },
        { to: '/servicii', label: t('servicii_page.title', 'Servicii'), ecranId: 'servicii', modul: 'scan-x', showForDistributor: true, showForGuest: true },
        { to: '/documente-tehnice', label: t('nav.doc_tehnice'), ecranId: 'doc-tehnice', modul: 'doc-tehnice', showForDistributor: false, showForGuest: false },
      ]
    },
    {
      title: t('nav.constructii', 'CONSTRUCTII'),
      titleColor: 'text-orange-600',
      dotColor: 'bg-orange-500',
      adminOnly: true,
      items: [
        { to: '/calcul-simplificat-constructii', label: t('nav.calcul_simplificat_constructii', 'Fundatii Simplificat'), ecranId: 'calcul-simplificat-constructii', modul: 'scan-x', adminOnly: true },
        { to: '/constructii', label: t('nav.constructii_case', 'Configurator fundatii'), ecranId: 'constructii', modul: 'constructii', adminOnly: true },
      ]
    },
    {
      title: t('nav.sistem', 'SISTEM'),
      titleColor: 'text-emerald-600',
      dotColor: 'bg-emerald-500',
      showForAll: true,
      showForGuest: true,
      items: [
        { to: '/media', label: t('nav.media'), ecranId: 'media', modul: 'media', showForDistributor: true, showForGuest: true },
        { to: '/date-firma', label: t('nav.date_firma', 'Date Firma'), ecranId: 'date-firma', modul: 'media', showForDistributor: true, showForGuest: true },
        { to: '/licenta', label: t('nav.licenta', 'Valabilitate licenta'), ecranId: 'licenta', modul: 'media', showForDistributor: true, showForGuest: true },
        { to: '/schimba-parola', label: t('nav.schimba_parola', 'Schimba parola'), ecranId: 'schimba-parola', modul: 'media', showForDistributor: true, showForGuest: true },
      ]
    },
    {
      title: 'BI',
      dotColor: 'bg-cyan-500',
      hideFromDistributor: true,
      items: [
        { to: '/oferte-admin', label: 'OFERTE ADMIN', ecranId: 'oferte-admin', modul: 'bi-evolutive' },
        { to: '/rapoarte-evolutive', label: 'Rapoarte evolutive', ecranId: 'bi-evolutive', modul: 'bi-evolutive' },
        { to: '/rapoarte-comparative', label: 'Rapoarte comparative', ecranId: 'bi-comparative', modul: 'bi-comparative' },
        { to: '/rata-succes', label: 'Rata succes', ecranId: 'rata-succes', modul: 'bi-comparative' },
        { to: '/top', label: 'TOP', ecranId: 'bi-top', modul: 'bi-comparative' },
        { to: '/rapoarte-dealeri-adaos-servicii', label: 'Dealeri adaos servicii', ecranId: 'bi-dealeri-adaos-servicii', modul: 'bi-comparative' },
        { to: '/rapoarte-utilizatori', label: 'Rapoarte utilizatori', ecranId: 'bi-evolutive', modul: 'bi-evolutive' },
        { to: '/descarcari', label: 'DESCARCARI', ecranId: 'descarcari', adminOnly: true },
      ]
    },
    {
      title: 'TEHNICI',
      dotColor: 'bg-indigo-500',
      hideFromDistributor: true,
      items: [
        { to: '/documente', label: 'Documente', ecranId: 'documente', modul: 'documente' },
        { to: '/imagini', label: 'Imagini', ecranId: 'imagini', modul: 'imagini' },
      ]
    },
    {
      title: 'DIVERSE',
      dotColor: 'bg-slate-500',
      hideFromDistributor: true,
      items: [
        { to: '/docu-p', label: 'Docu-P', ecranId: 'docu-p', modul: 'docu-p' },
        { to: '/tipuri-optiuni', label: 'Tipuri Optiuni', ecranId: 'tipuri-optiuni', adminOnly: true },
        { to: '/obloane/tipologii', label: 'Tipologii Obloane', ecranId: 'obloane-tipologii', modul: 'scan-x' },
        { to: '/tipologii', label: 'Tipologii Ferestre/Usi', ecranId: 'tipologii', modul: 'tipologii' },
        { to: '/profile-suplimentare', label: 'Profile Supl.', ecranId: 'profile-supl', modul: 'profile-supl', hasPreturi: true },
        { to: '/accesorii', label: 'Accesorii', ecranId: 'accesorii', modul: 'accesorii', hasPreturi: true },
      ]
    },
    {
      title: 'CORELATII',
      dotColor: 'bg-amber-500',
      hideFromDistributor: true,
      items: [
        { to: '/obloane/corelatii-brut', label: 'Corelatii Brut', ecranId: 'obloane-corelatii-brut', modul: 'scan-x' },
        { to: '/corelatii-ps', label: 'Corelatii PS', ecranId: 'corelatii-ps', modul: 'profile-supl', hasPreturi: true },
        { to: '/corelatii/lemn', label: 'Corelatii lemn', ecranId: 'cor-lemn', modul: 'cor-lemn' },
        { to: '/corelatii/vopsea', label: 'Corelatii vopsea', ecranId: 'cor-vopsea', modul: 'cor-vopsea' },
        { to: '/corelatii/prelucrari', label: 'Corelatii prelucrari', ecranId: 'cor-prelucrari', modul: 'cor-lemn' },
        { to: '/corelatii/feronerie', label: 'CorFeron', ecranId: 'cor-feronerie', modul: 'cor-feronerie' },
        { to: '/corelatii/finisaj', label: 'CorFinis', ecranId: 'cor-finisaj', modul: 'cor-lemn' },
        { to: '/corelatii/gt', label: 'CorGT', ecranId: 'cor-gt', modul: 'cor-lemn' },
        { to: '/corelatii/surub', label: 'CorSurub', ecranId: 'cor-surub', modul: 'cor-lemn' },
        { to: '/corelatii/sticla', label: 'Corelatii sticla', ecranId: 'cor-sticla', modul: 'cor-sticla' },
      ]
    },
    {
      title: 'CONFIGURARE OBLOANE',
      dotColor: 'bg-amber-500',
      hideFromDistributor: true,
      items: [
        { to: '/obloane/profile', label: 'Profile', ecranId: 'obloane-profile', modul: 'scan-x' },
        { to: '/obloane/feronerie-tipuri', label: 'Feronerie Tipuri', ecranId: 'obloane-feronerie-tipuri', modul: 'scan-x' },
        { to: '/obloane/feronerie-seturi', label: 'Feronerie Seturi', ecranId: 'obloane-feronerie-seturi', modul: 'scan-x' },
        { to: '/obloane/lamele-preturi', label: 'Lamele Preturi', ecranId: 'obloane-lamele-preturi', modul: 'scan-x' },
        { to: '/obloane/lemn', label: 'Lemn', ecranId: 'obloane-lemn-cfg', modul: 'scan-x', hasPreturi: true },
        { to: '/obloane/dimensiuni', label: 'Dimensiuni', ecranId: 'obloane-dimensiuni', modul: 'scan-x' },
      ]
    },
    {
      title: 'CONFIGURARE',
      dotColor: 'bg-blue-500',
      hideFromDistributor: true,
      items: [
        { to: '/culori', label: 'Culori', ecranId: 'culori', modul: 'culori', hasPreturi: true },
        { to: '/lemn', label: 'Lemn', ecranId: 'lemn', modul: 'lemn', hasPreturi: true },
        { to: '/finisaj', label: 'Finisaj', ecranId: 'finisaj-cfg', modul: 'finisaj', hasPreturi: true },
        { to: '/geam', label: 'Geam', ecranId: 'geam', modul: 'geam', hasPreturi: true },
        { to: '/dimensiuni', label: 'Dimensiuni', ecranId: 'dimensiuni', modul: 'dimensiuni' },
        { to: '/jocuri', label: 'Jocuri', ecranId: 'jocuri', modul: 'jocuri' },
        { to: '/cote-vitraj', label: 'Cote Vitraj', ecranId: 'cote-vitraj', modul: 'cote-vitraj' },
        { to: '/speciale', label: 'Speciale', ecranId: 'speciale', modul: 'speciale', hasPreturi: true },
        { to: '/sprose', label: 'Sprose', ecranId: 'sprose', modul: 'sprose', hasPreturi: true },
      ]
    },
    {
      title: 'ACCESORIZARE',
      dotColor: 'bg-amber-500',
      hideFromDistributor: true,
      items: [
        { to: '/scheme', label: 'Scheme', ecranId: 'scheme', modul: 'scheme', hasPreturi: true },
        { to: '/feronerie-setup', label: 'Feronerie', ecranId: 'feronerie-cfg', modul: 'feronerie-cfg', hasPreturi: true },
        { to: '/feronerie-seturi', label: 'Seturi Fer.', ecranId: 'seturi-fer', modul: 'seturi-fer', hasPreturi: true },
        { to: '/scheme-feronerie-usi', label: 'Sch.Fer.Usi', ecranId: 'scheme-fer-usi', modul: 'scheme-fer-usi', hasPreturi: true },
        { to: '/praguri', label: 'Praguri', ecranId: 'praguri', modul: 'praguri', hasPreturi: true },
        { to: '/picuratori', label: 'Picuratori', ecranId: 'picuratori', modul: 'picuratori', hasPreturi: true },
        { to: '/etansare', label: 'Etansare', ecranId: 'etansare', modul: 'etansare', hasPreturi: true },
        { to: '/placari', label: 'Placari AL', ecranId: 'placari', modul: 'placari', hasPreturi: true },
      ]
    },
    {
      title: 'OPERATII',
      dotColor: 'bg-fuchsia-500',
      hideFromDistributor: true,
      items: [
        { to: '/operatii/lemn', label: 'Lemn', ecranId: 'op-lemn', modul: 'op-lemn', hasPreturi: true },
        { to: '/operatii/orificii', label: 'Orificii', ecranId: 'op-orificii', modul: 'op-orificii', hasPreturi: true },
        { to: '/operatii/finisaj', label: 'Finisaj', ecranId: 'op-finisaj', modul: 'op-finisaj' },
        { to: '/operatii/feronerie', label: 'Feronerie', ecranId: 'op-feronerie', modul: 'op-feronerie', hasPreturi: true },
        { to: '/operatii/geam', label: 'Geam', ecranId: 'op-geam', modul: 'op-geam', hasPreturi: true },
        { to: '/operatii/finale', label: 'Finale', ecranId: 'op-finale', modul: 'op-finale', hasPreturi: true },
        { to: '/operatii/deseuri', label: 'Deseuri', ecranId: 'op-deseuri', modul: 'op-deseuri', hasPreturi: true },
      ]
    },
    {
      title: 'CONTABILITATE',
      dotColor: 'bg-green-500',
      hideFromDistributor: true,
      items: [
        { to: '/feronerie', label: 'Feronerie', ecranId: 'ct-feronerie', modul: 'ct-feronerie' },
        { to: '/costuri', label: 'Costuri Fixe', ecranId: 'costuri', modul: 'costuri' },
        { to: '/variabile-lunare', label: 'Variabile Lunare', ecranId: 'var-lunare', modul: 'var-lunare' },
        { to: '/pierderi', label: 'Pierderi', ecranId: 'pierderi', modul: 'pierderi' },
        { to: '/furnizori', label: 'Furnizori', ecranId: 'furnizori', modul: 'furnizori' },
        { to: '/produse', label: 'Produse Master', ecranId: 'produse', modul: 'produse' },
        { to: '/mapari', label: 'Mapari Preturi', ecranId: 'mapari', modul: 'mapari' },
        { to: '/facturi', label: 'Facturi Import', ecranId: 'facturi', modul: 'facturi' },
        { to: '/import-preturi', label: 'Import Preturi', ecranId: 'import-preturi', modul: 'import-preturi' },
      ]
    },
    {
      title: 'SISTEM',
      dotColor: 'bg-red-500', // Puncte rosii
      items: [
        { to: '/grupuri', label: 'Grupuri', ecranId: 'grupuri', modul: 'grupuri', adminOnly: true },
        { to: '/drepturi', label: 'Drepturi', ecranId: 'drepturi', modul: 'drepturi', adminOnly: true },
        { to: '/utilizatori', label: 'Utilizatori', ecranId: 'utilizatori', modul: 'utilizatori', adminOnly: true },
        { to: '/sesiuni', label: 'Sesiuni', ecranId: 'sesiuni', modul: 'utilizatori' },
        { to: '/statistici-clicuri', label: 'Statistici clicuri', ecranId: 'statistici-clicuri', modul: 'utilizatori' },
      ]
    }
  ];

  const isDistributor = user?.rol === 'distribuitor';
  const isGuest = user?.rol === 'guest';

  // Pentru guest, itemele complexe (regLock) nu navigheaza ci afiseaza un mesaj
  // de invitatie la inregistrare. Distribuitor/operator/admin navigheaza normal.
  const handleNavClick = (e, item) => {
    if (isGuest && item.regLock) {
      e.preventDefault();
      toast.error(t('welcome_constructii.guest_locked', 'Disponibil pentru utilizatorii inregistrati'), {
        action: { label: t('welcome_constructii.guest_locked_cta', 'Inregistreaza-te'), onClick: () => navigate('/register') },
      });
      setSidebarOpen(false);
      return;
    }
    trackClick('nav_click', { to: item.to, label: typeof item.label === 'string' ? item.label : '' });
    setSidebarOpen(false);
  };

  // Filtreaza elementele de navigare in functie de permisiuni SI rol
  const getFilteredItems = (items, section) => {
    return items.filter(item => {
      // Ascunde ScanX in demo (flag build), fara a atinge grupul de permisiuni scan-x
      if (item.ecranId === 'scan-x' && HIDE_SCANX) return false;
      // Ascunde Obloane in demo PVC (flag build), fara a atinge grupul de permisiuni scan-x
      if (HIDE_OBLOANE && (item.to === '/calcul-simplificat-obloane' || (typeof item.to === 'string' && item.to.startsWith('/obloane')))) return false;
      if (isDistributor && typeof item.to === 'string' && item.to.includes('constructii')) return false;
      // Admin-only check
      if (item.adminOnly && !isAdmin) return false;

      // Guest - whitelist explicit
      if (isGuest) {
        return item.showForGuest === true;
      }

      // Pentru distribuitori - arata doar itemii marcati explicit
      if (isDistributor) {
        return item.showForDistributor === true;
      }

      // Pentru admin/operatori - verifica permisiunile normal.
      // Fallback la modul legacy daca ecranId nu este setat in permisiuni (grupuri ne-migrate).
      return canView(item.ecranId || item.modul, item.modul);
    });
  };

  // Filtreaza sectiunile pentru distribuitori
  const getVisibleSections = () => {
    return navSections.filter(section => {
      if (section.adminOnly && !isAdmin) return false;
      if (isGuest) {
        return section.showForGuest === true;
      }
      if (isDistributor) {
        // Distribuitorii vad doar sectiunile showForAll sau distributorSection
        return section.showForAll === true || section.distributorSection === true;
      }
      // Admin/operatori vad tot EXCEPTAND sectiunile exclusive pentru distribuitori
      if (section.hideFromDistributor && isDistributor) {
        return false;
      }
      return true;
    });
  };

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="lg:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b z-40 flex items-center justify-between px-3 gap-2">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="flex-shrink-0">
          {sidebarOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
        <div className="flex-1 min-w-0">
          <GlobalSearch />
        </div>
        {/* Sesiune 31 iter 20: eliminat butonul Logout duplicat de pe bara mobile (logout ramane in top header sticky). */}
      </div>

      <aside className={`
        fixed top-0 left-0 bottom-0 ${panouCompact ? 'lg:w-12 lg:overflow-hidden' : 'w-64'} bg-white border-r z-30 transform transition-all flex flex-col
        lg:translate-x-0 ${sidebarOpen ? 'translate-x-0 w-64' : '-translate-x-full'}
      `}>
        {panouCompact && (
          <button
            onClick={() => window.dispatchEvent(new CustomEvent('panou-compact-mode', { detail: { compact: false } }))}
            className="hidden lg:flex items-center justify-center h-10 text-slate-500 hover:bg-slate-100 flex-shrink-0"
            title="Extinde meniul"
            data-testid="sidebar-expand-btn"
          >
            <Menu className="h-5 w-5" />
          </button>
        )}
        <div className="h-14 flex items-center px-6 border-b flex-shrink-0 justify-between gap-2">
          <span className="font-bold text-xl text-blue-600">Oferte Amel</span>
          {!panouCompact && (
            <button
              onClick={() => window.dispatchEvent(new CustomEvent('panou-compact-mode', { detail: { compact: true } }))}
              className="hidden lg:flex items-center justify-center w-7 h-7 text-slate-500 hover:bg-slate-100 rounded"
              title="Ascunde meniul"
              data-testid="sidebar-collapse-btn"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
          )}
        </div>
        <div className="px-4 py-2 border-b hidden lg:block flex-shrink-0">
          <GlobalSearch />
        </div>

        <nav className="p-4 space-y-1 overflow-y-auto flex-1 pb-16">
          {/* Sesiune 31 iter 18: header mobile cu nume + delogare + limba (vizibil doar in slidebar mobile) */}
          <div className="lg:hidden border-b pb-3 mb-3 space-y-2">
            <div className="px-2 text-xs">
              <p className="font-medium text-slate-900 truncate">{user?.nume || user?.email}</p>
              <p className="text-slate-500 capitalize">{t(`nav.${user?.rol || 'operator'}`, user?.rol || 'operator')}</p>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-slate-700 hover:bg-slate-100"
              data-testid="sidebar-mobile-logout"
            >
              <LogOut className="h-4 w-4 text-slate-500" />
              {t('nav.logout')}
            </button>
            <div className="px-2">
              <LanguageSelector mode="profile" dropdownDirection="down" />
            </div>
          </div>
          {getVisibleSections().map((section, sectionIdx) => {
            const filteredItems = getFilteredItems(section.items, section);
            if (filteredItems.length === 0) return null;
            
            return (
              <div key={sectionIdx}>
                {section.title && (
                  <div className={`text-[10px] font-semibold uppercase tracking-wider px-3 pt-4 pb-2 ${section.titleColor || 'text-slate-400'}`}>
                    {section.title}
                  </div>
                )}
                {section.twoColumns ? (
                  <div className="grid grid-cols-2 gap-x-1 gap-y-0">
                    {filteredItems.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        onClick={(e) => handleNavClick(e, item)}
                        className={`flex items-center gap-2 px-2 py-1.5 rounded-lg transition-colors text-xs ${
                          isActive(item.to)
                            ? 'bg-blue-50 text-blue-700 font-medium'
                            : 'text-slate-700 hover:bg-slate-100'
                        }`}
                      >
                        <span className="flex items-center gap-0.5 flex-shrink-0">
                          <span className={`w-1.5 h-1.5 rounded-full ${section.dotColor}`} />
                        </span>
                        <span className="truncate">{item.label}</span>
                      </Link>
                    ))}
                  </div>
                ) : (
                  filteredItems.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      onClick={(e) => handleNavClick(e, item)}
                      className={`flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-sm ${
                        isActive(item.to)
                          ? 'bg-blue-50 text-blue-700 font-medium'
                          : 'text-slate-700 hover:bg-slate-100'
                      }`}
                    >
                      {item.icon ? (
                        <item.icon className={`h-4 w-4 ${isActive(item.to) ? 'text-blue-600' : 'text-slate-500'}`} />
                      ) : (
                        <span className="flex items-center gap-0.5">
                          <span className={`w-2 h-2 rounded-full ${section.dotColor}`} />
                        </span>
                      )}
                      {item.label}
                    </Link>
                  ))
                )}
              </div>
            );
          })}
        </nav>

        <div className="flex-shrink-0 p-2 border-t bg-white">
          <button
            onClick={(e) => { e.stopPropagation(); cycleFontSize(); }}
            className="w-full flex items-center justify-center p-2 text-slate-500 hover:text-blue-500 active:scale-90 transition-all"
            title={`Text: ${fontSize}%`}
            data-testid="font-size-toggle"
          >
            <Type className="h-5 w-5" />
            <span className="text-[10px] ml-1">{fontSize}%</span>
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/30 z-20"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <main className={`${panouCompact ? 'lg:ml-12' : 'lg:ml-64'} pt-14 lg:pt-0 min-h-screen`}>
        {/* Sesiune 31 iter 16: bara top cu User + Logout + Language (mutate de jos sus, vizibile pe toate device-urile)
            Sesiune 46: + miniatura sectiune profil fereastra (vizibila pe toate paginile, click pentru marire). */}
        <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200 px-3 py-2 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setBrandLightboxOpen(true)}
              className="flex-shrink-0 rounded border border-slate-200 overflow-hidden hover:border-blue-400 transition-colors"
              title={t('brand_profile_title', 'Sectiune profil fereastra')}
              data-testid="brand-profile-thumb-btn"
            >
              <img
                src="/brand-window-profile.jpeg"
                alt={t('brand_profile_title')}
                className="h-9 w-9 object-cover cursor-zoom-in"
              />
            </button>
            <span className="hidden md:inline text-[11px] text-slate-500">{t('brand_profile_title', 'Sectiune profil')}</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-xs text-right">
              <p className="font-medium leading-tight">{user?.nume || user?.email}</p>
              <p className="text-slate-500 capitalize leading-tight">{t(`nav.${user?.rol || 'operator'}`, user?.rol || 'operator')}</p>
            </div>
            <LanguageSelector mode="profile" dropdownDirection="down" />
            <button
              onClick={handleLogout}
              className="p-2 text-slate-500 hover:text-red-500 transition-colors rounded border border-slate-300"
              data-testid="header-logout-btn"
              title={t('nav.logout')}
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
        {isGuest && (
          <div className="bg-amber-50 border-b border-amber-200 px-3 py-2 text-center text-xs sm:text-sm text-amber-900" data-testid="guest-auth-banner">
            {t('guest_banner.must_authenticate', 'Pentru a putea pastra istoricul ofertelor si comenzilor este necesar sa va autentificati.')}
          </div>
        )}
        {adaosWarn && (
          <div className="bg-yellow-100 border-b border-yellow-300 px-3 py-2 flex items-center justify-between gap-3 text-xs sm:text-sm text-yellow-900" data-testid="adaos-warning-banner">
            <span className="font-semibold">{t('adaos_warning.message', 'Atentie: verificati adaos din sectiunea Servicii')}</span>
            <button
              type="button"
              onClick={dismissAdaosWarn}
              className="flex-shrink-0 h-7 w-7 rounded hover:bg-yellow-200 flex items-center justify-center"
              aria-label={t('common.close')}
              data-testid="adaos-warning-dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        )}
        {brandLightboxOpen && (
          <div
            className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-6 cursor-zoom-out"
            onClick={() => setBrandLightboxOpen(false)}
            data-testid="brand-profile-lightbox"
          >
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setBrandLightboxOpen(false); }}
              className="absolute top-4 right-4 z-[101] h-10 w-10 rounded-full bg-white/90 hover:bg-white text-slate-800 flex items-center justify-center shadow-lg"
              aria-label={t('common.close')}
              data-testid="brand-profile-lightbox-close"
            >
              <X className="h-5 w-5" />
            </button>
            <img
              src="/brand-window-profile.jpeg"
              alt={t('brand_profile_title')}
              className="max-w-full max-h-full object-contain rounded shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
        {children}
      </main>
      <WhatsAppFloat />
    </div>
  );
};

const ProtectedRoute = ({ children, modul, adminOnly, hideForDistributor }) => {
  const { token, loading, canView, isAdmin, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-indigo-600 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (hideForDistributor && user?.rol === 'distribuitor') {
    return <Navigate to="/welcome" replace />;
  }

  if (modul && !canView(modul)) {
    // Daca nu are acces la dashboard, redirecteaza la proiectare
    if (modul === 'dashboard' && canView('proiectare')) {
      return <Navigate to="/proiectare" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <Layout><React.Suspense fallback={<PageFallback />}>{children}</React.Suspense></Layout>;
};

// Sesiune 37: emite pageview la fiecare schimbare de ruta, pe orice ruta (publica sau privata).
// Skip-ul admin este facut in trackPageview (citeste oferte_user din storage).
const RouteTracker = () => {
  const location = useLocation();
  React.useEffect(() => {
    trackPageview(location.pathname + (location.search || ''));
  }, [location.pathname, location.search]);
  return null;
};

// Sesiune 78: hook auto-reload la versiune noua backend
function useVersionCheck() {
  const [initialVersion, setInitialVersion] = useState(null);
  const [reloadShown, setReloadShown] = useState(false);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL || '';
    let cancelled = false;

    const fetchVersion = async () => {
      try {
        const r = await fetch(`${API}/api/version`, { cache: 'no-store' });
        if (!r.ok) return null;
        const data = await r.json();
        return data.version || null;
      } catch {
        return null;
      }
    };

    (async () => {
      const v = await fetchVersion();
      if (!cancelled && v) setInitialVersion(v);
    })();

    const id = setInterval(async () => {
      if (cancelled || reloadShown || !initialVersion) return;
      const v = await fetchVersion();
      if (!v || v === initialVersion) return;
      setReloadShown(true);
      toast.success('Versiune noua disponibila. Aplicatia se va reincarca in 30 secunde.', {
        duration: 30000,
        action: {
          label: 'Reincarca acum',
          onClick: () => window.location.reload(),
        },
      });
      setTimeout(() => window.location.reload(), 30000);
    }, 60000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [initialVersion, reloadShown]);
}



function App() {
  // Sesiune 78: Version Check auto-reload
  // Distribuitorii si guest pot ramane cu tab-ul deschis zile intregi cu versiunea veche.
  // Polling la 60s: cand backend bump-eaza APP_VERSION, afisam toast cu reload (auto dupa 30s).
  useVersionCheck();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <LeadCaptureGate />
        <RouteTracker />
        <React.Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/uitat-parola" element={<UitatParolaPage />} />
          <Route path="/reseteaza-parola" element={<ReseteazaParolaPage />} />
          <Route path="/activare" element={<ActivareCampaniePage />} />
          <Route path="/welcome" element={<ProtectedRoute><WelcomePage /></ProtectedRoute>} />
          <Route path="/categorii" element={<Navigate to="/welcome" replace />} />
          <Route path="/harta-site" element={<ProtectedRoute><SitemapPage /></ProtectedRoute>} />
          <Route path="/calcul-simplificat-obloane" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute><CalculSimplificatObloanePage /></ProtectedRoute>} />
          <Route path="/calcul-simplificat-ferestre-usi" element={<ProtectedRoute><CalculSimplificatFerestreUsiPage /></ProtectedRoute>} />
          <Route path="/calcul-simplificat-constructii" element={<ProtectedRoute adminOnly><CalculSimplificatConstructiiPage /></ProtectedRoute>} />
          <Route path="/bun-venit-constructii" element={<ProtectedRoute adminOnly><WelcomeConstructiiPage /></ProtectedRoute>} />
          <Route path="/date-firma" element={<ProtectedRoute><FirmaDataPage /></ProtectedRoute>} />
          <Route path="/schimba-parola" element={<ProtectedRoute><SchimbaParolaPage /></ProtectedRoute>} />
          <Route path="/licenta" element={<ProtectedRoute><ValabilitateLicentaPage /></ProtectedRoute>} />
          <Route path="/istoric-oferte" element={<ProtectedRoute><IstoricOfertePage /></ProtectedRoute>} />
          <Route path="/forme-neregulate" element={<ProtectedRoute><FormaNeregulataPage /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute modul="dashboard"><Dashboard /></ProtectedRoute>} />
          
          {/* OFERTARE */}
          <Route path="/scan-x" element={HIDE_SCANX ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x"><ScanXPage /></ProtectedRoute>} />
          <Route path="/voce" element={HIDE_SCANX ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x"><VocePage /></ProtectedRoute>} />
          <Route path="/configurator" element={<ProtectedRoute modul="scan-x"><ConfiguratorPage /></ProtectedRoute>} />
          <Route path="/obloane" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x"><ObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/profile" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><ProfileObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/tipologii" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><TipologiiObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/corelatii-brut" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><CorelatiiObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/feronerie-tipuri" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><FeronerieTipuriObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/feronerie-seturi" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><FeronerieSeturiObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/lamele-preturi" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><LamelePreturiObloanePage /></ProtectedRoute>} />
          <Route path="/obloane/lemn" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><ObloaneLemnPage /></ProtectedRoute>} />
          <Route path="/obloane/dimensiuni" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x" adminOnly><ObloaneDimensiuniPage /></ProtectedRoute>} />
          <Route path="/obloane-lemn" element={HIDE_OBLOANE ? <Navigate to="/welcome" replace /> : <ProtectedRoute modul="scan-x"><OblonLemnOfertarePage /></ProtectedRoute>} />
          <Route path="/oferte" element={<Navigate to="/scan-x" replace />} />
          <Route path="/proiectare" element={<Navigate to="/scan-x" replace />} />
          <Route path="/proiectare/:ofertaId" element={<Navigate to="/scan-x" replace />} />
          <Route path="/documente" element={<ProtectedRoute modul="documente"><DocumentePage /></ProtectedRoute>} />
          <Route path="/docu-p" element={<ProtectedRoute modul="docu-p"><DocuPPage /></ProtectedRoute>} />
          
          {/* CORELATII */}
          <Route path="/corelatii/:tip" element={<ProtectedRoute modul="cor-lemn"><CorelatiiPage /></ProtectedRoute>} />
          
          {/* BI */}
          <Route path="/rapoarte-evolutive" element={<ProtectedRoute modul="bi-evolutive"><BIEvolutivePage /></ProtectedRoute>} />
          <Route path="/oferte-admin" element={<ProtectedRoute modul="bi-evolutive"><OferteAdminPage /></ProtectedRoute>} />
          <Route path="/rapoarte-comparative" element={<ProtectedRoute modul="bi-comparative"><BIComparativTariPage /></ProtectedRoute>} />
          <Route path="/rata-succes" element={<ProtectedRoute modul="bi-comparative"><BIRataSuccesPage /></ProtectedRoute>} />
          <Route path="/top" element={<ProtectedRoute modul="bi-comparative"><BITopPage /></ProtectedRoute>} />
          <Route path="/rapoarte-dealeri-adaos-servicii" element={<ProtectedRoute modul="bi-comparative"><BIDealerAdaosServiciiPage /></ProtectedRoute>} />
          <Route path="/rapoarte-utilizatori" element={<ProtectedRoute modul="bi-evolutive"><RapoarteUtilizatoriPage /></ProtectedRoute>} />
          <Route path="/descarcari" element={<ProtectedRoute adminOnly><DescarcariPage /></ProtectedRoute>} />
          <Route path="/constructii" element={<ProtectedRoute adminOnly><ConstructiiPage /></ProtectedRoute>} />
          <Route path="/constructii/:id" element={<ProtectedRoute adminOnly><ConstructiiProiectPage /></ProtectedRoute>} />
          <Route path="/comenzi-mele" element={<ProtectedRoute modul="scan-x"><ComenzileMelePage /></ProtectedRoute>} />
          <Route path="/servicii" element={<ProtectedRoute modul="scan-x"><ServiciiPage /></ProtectedRoute>} />
          
          {/* CONFIGURARE */}
          <Route path="/culori" element={<ProtectedRoute modul="culori"><CuloriPage /></ProtectedRoute>} />
          <Route path="/lemn" element={<ProtectedRoute modul="lemn"><LemnPage /></ProtectedRoute>} />
          <Route path="/geam" element={<ProtectedRoute modul="geam"><GeamPage /></ProtectedRoute>} />
          <Route path="/dimensiuni" element={<ProtectedRoute modul="dimensiuni"><DimensiuniPage /></ProtectedRoute>} />
          <Route path="/jocuri" element={<ProtectedRoute modul="jocuri"><JocuriPage /></ProtectedRoute>} />
          <Route path="/cote-vitraj" element={<ProtectedRoute modul="cote-vitraj"><CoteVitrajPage /></ProtectedRoute>} />
          <Route path="/media" element={<ProtectedRoute><MediaPage /></ProtectedRoute>} />
          <Route path="/documente-tehnice" element={<ProtectedRoute modul="doc-tehnice"><DocumenteTehnicePage /></ProtectedRoute>} />
          <Route path="/speciale" element={<ProtectedRoute modul="speciale"><SpecialePage /></ProtectedRoute>} />
          <Route path="/sprose" element={<ProtectedRoute modul="sprose"><SprosePage /></ProtectedRoute>} />
          <Route path="/accesorii" element={<ProtectedRoute modul="accesorii"><AccesoriiPage /></ProtectedRoute>} />
          <Route path="/profile-suplimentare" element={<ProtectedRoute modul="profile-supl"><ProfileSuplimentarePage /></ProtectedRoute>} />
          <Route path="/corelatii-ps" element={<ProtectedRoute modul="profile-supl"><CorelatiiPSPage /></ProtectedRoute>} />
          <Route path="/imagini" element={<ProtectedRoute modul="imagini"><ImaginiPage /></ProtectedRoute>} />
          <Route path="/calculatii" element={<ProtectedRoute modul="cor-lemn"><CalculatiiPage /></ProtectedRoute>} />
          
          {/* ACCESORIZARE */}
          <Route path="/tipologii" element={<ProtectedRoute modul="tipologii"><TipologiiPage /></ProtectedRoute>} />
          <Route path="/scheme" element={<ProtectedRoute modul="scheme"><SchemePage /></ProtectedRoute>} />
          <Route path="/feronerie-setup" element={<ProtectedRoute modul="feronerie-cfg"><FeronerieSetupPage /></ProtectedRoute>} />
          <Route path="/feronerie-seturi" element={<ProtectedRoute modul="seturi-fer"><FeronerieSeturiPage /></ProtectedRoute>} />
          <Route path="/scheme-feronerie-usi" element={<ProtectedRoute modul="scheme-fer-usi"><SchemeFeronerieUsiPage /></ProtectedRoute>} />
          <Route path="/praguri" element={<ProtectedRoute modul="praguri"><PraguriPage /></ProtectedRoute>} />
          <Route path="/picuratori" element={<ProtectedRoute modul="picuratori"><PicuratoriPage /></ProtectedRoute>} />
          <Route path="/tipuri-optiuni" element={<ProtectedRoute adminOnly><TipuriOptiuniPage /></ProtectedRoute>} />
          <Route path="/etansare" element={<ProtectedRoute modul="etansare"><EtansarePage /></ProtectedRoute>} />
          <Route path="/placari" element={<ProtectedRoute modul="placari"><PlacariPage /></ProtectedRoute>} />
          
          {/* OPERATII */}
          <Route path="/operatii" element={<ProtectedRoute modul="op-lemn"><OperatiiPage /></ProtectedRoute>} />
          <Route path="/operatii/:categorie" element={<ProtectedRoute modul="op-lemn"><OperatiiPage /></ProtectedRoute>} />
          
          {/* CONTABILITATE */}
          <Route path="/feronerie" element={<ProtectedRoute modul="ct-feronerie"><FeronerePage /></ProtectedRoute>} />
          <Route path="/finisaj" element={<ProtectedRoute modul="finisaj"><FinisajPage /></ProtectedRoute>} />
          <Route path="/costuri" element={<ProtectedRoute modul="costuri"><CosturiPage /></ProtectedRoute>} />
          <Route path="/furnizori" element={<ProtectedRoute modul="furnizori"><Furnizori /></ProtectedRoute>} />
          <Route path="/produse" element={<ProtectedRoute modul="produse"><Produse /></ProtectedRoute>} />
          <Route path="/mapari" element={<ProtectedRoute modul="mapari"><Mapari /></ProtectedRoute>} />
          <Route path="/facturi" element={<ProtectedRoute modul="facturi"><Facturi /></ProtectedRoute>} />
          <Route path="/import-preturi" element={<ProtectedRoute modul="import-preturi"><ImportPreturiPage /></ProtectedRoute>} />
          <Route path="/variabile-lunare" element={<ProtectedRoute modul="var-lunare"><VariabileLunarePage /></ProtectedRoute>} />
          <Route path="/pierderi" element={<ProtectedRoute modul="pierderi"><PierderiPage /></ProtectedRoute>} />
          
          {/* SISTEM */}
          <Route path="/grupuri" element={<ProtectedRoute modul="grupuri" adminOnly><Grupuri /></ProtectedRoute>} />
          <Route path="/drepturi" element={<ProtectedRoute modul="drepturi" adminOnly><Drepturi /></ProtectedRoute>} />
          <Route path="/utilizatori" element={<ProtectedRoute modul="utilizatori" adminOnly><Utilizatori /></ProtectedRoute>} />
          <Route path="/sesiuni" element={<ProtectedRoute modul="sesiuni"><SesiuniPage /></ProtectedRoute>} />
          <Route path="/statistici-clicuri" element={<ProtectedRoute modul="statistici-clicuri"><StatisticiClicuriPage /></ProtectedRoute>} />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </React.Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
